"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Popover = void 0;

var _tslib = require("tslib");

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _slice = require("@lce/slice");

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj["default"] = obj;
    return newObj;
  }
}

var activeCaret = (0, _styledComponents.css)(templateObject_1 || (templateObject_1 = (0, _tslib.__makeTemplateObject)(["\n  ::after,\n  ::before {\n    content: '';\n    display: block;\n    position: absolute;\n    bottom: calc(100% - 20px);\n    left: calc(50%);\n    transform: translateX(-50%);\n    width: 0;\n    height: 0;\n  }\n\n  ::after {\n    border-left: 8px solid transparent;\n    border-right: 8px solid transparent;\n    border-bottom: 8px solid white;\n  }\n\n  ::before {\n    border-left: 14px solid transparent;\n    border-right: 14px solid transparent;\n    border-bottom: 14px solid ", ";\n  }\n"], ["\n  ::after,\n  ::before {\n    content: '';\n    display: block;\n    position: absolute;\n    bottom: calc(100% - 20px);\n    left: calc(50%);\n    transform: translateX(-50%);\n    width: 0;\n    height: 0;\n  }\n\n  ::after {\n    border-left: 8px solid transparent;\n    border-right: 8px solid transparent;\n    border-bottom: 8px solid white;\n  }\n\n  ::before {\n    border-left: 14px solid transparent;\n    border-right: 14px solid transparent;\n    border-bottom: 14px solid ", ";\n  }\n"])), function (_a) {
  var theme = _a.theme;
  return theme.colors.orange;
});
var Popover = (0, _styledComponents["default"])(_slice.Box)(templateObject_2 || (templateObject_2 = (0, _tslib.__makeTemplateObject)(["\n  width: 256px;\n  padding: 16px;\n  margin-top: 16px;\n  ", "\n  border-color: ", ";\n  border-width: 4px;\n  border-style: solid;\n  background-color: ", ";\n  text-align: center;\n"], ["\n  width: 256px;\n  padding: 16px;\n  margin-top: 16px;\n  ", "\n  border-color: ", ";\n  border-width: 4px;\n  border-style: solid;\n  background-color: ", ";\n  text-align: center;\n"])), activeCaret, function (_a) {
  var theme = _a.theme;
  return theme.colors.orange;
}, function (_a) {
  var theme = _a.theme;
  return theme.colors.white;
});
exports.Popover = Popover;
var templateObject_1, templateObject_2;